import React from "react"
import Layout from "../../components/Layout"
import ContactForm from "../../components/contactForm"
import "../../styles/app.scss"
import useSiteMetadata from "../../components/SiteMetadata"
import ReactWOW from "react-wow"
import "animate.css"
import { graphql, PageProps } from "gatsby"
import "../../styles/pages/contact.scss"
import Icon from "@mdi/react"
import Img from "gatsby-image"
import { mdiFacebook, mdiTwitter, mdiInstagram } from "@mdi/js"
import { GatsbyImage, Newsletter } from "@wp/ui"

type ContactPageData = {
  image: GatsbyImage
}

const Index: React.FC<PageProps<ContactPageData>> = ({ data }) => {
  const {
    image: {
      childImageSharp: { fluid: aboutPageBanner },
    },
  } = data
  const { email, facebook, twitter, instagram } = useSiteMetadata()

  return (
    <Layout
      title="Contact"
      id="contact-page"
      leftSide={
        <ReactWOW animation="fadeIn">
          <div className="banner-image animate__animated">
            <Img fluid={aboutPageBanner} alt="about page banner" />
          </div>
        </ReactWOW>
      }
      rightSide={
        <div className="page-container">
          <div className="container">
            <h1 className="font-head font-xl">Contact</h1>
            <section className="content">
              <div className="contact-form-section">
                <h2 className="font-head font-lg sub-head">Have questions?</h2>
                <ContactForm actionURL="/" />
              </div>
              <div className="contact-info">
                <ul>
                  <li className="contact-info-list">
                    <div>
                      <h2 className="font-head font-lg sub-head">
                        Contact Information
                      </h2>
                      <a
                        className="font-body font-sm"
                        href="tel:+(239)2847-282"
                      >
                        +(239)2847-282
                      </a>
                      <p>
                        <a
                          className="font-body font-sm"
                          href={`mailto:${email}`}
                        >
                          {email}
                        </a>
                      </p>
                    </div>
                  </li>
                  <li className="contact-info-list">
                    <div>
                      <h2 className="font-head font-lg sub-head">Social</h2>
                      <ul className="social-links">
                        <li>
                          {facebook && (
                            <a
                              className="btn btn-box"
                              href={facebook}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon path={mdiFacebook} size={1} color="#222" />
                            </a>
                          )}
                        </li>
                        <li>
                          {twitter && (
                            <a
                              className="btn btn-box"
                              href={twitter}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon path={mdiTwitter} size={1} color="#222" />
                            </a>
                          )}
                        </li>
                        <li>
                          {instagram && (
                            <a
                              className="btn btn-box"
                              href={instagram}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Icon path={mdiInstagram} size={1} color="#222" />
                            </a>
                          )}
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="contact-info-list">
                    <div>
                      <h2 className="font-head font-lg sub-head">
                        Join the community
                      </h2>
                      <Newsletter
                        id="newsletter"
                        mailchimpURL="https://gmail.us17.list-manage.com/subscribe/post?u=4ce70e65553c75b0ba1146272&amp;id=6731f94b1c"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </section>
          </div>
        </div>
      }
    />
  )
}
export default Index

export const pageQuery = graphql`
  query {
    image: file(relativePath: { eq: "nahil-naseer-xljtGZ2-P3Y-unsplash.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 60) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
